// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__TuXN3","rotation":"loader_rotation__vipyi"};